import { FullName as CanadaFullNamePb } from "@repo/protobuf/gen/kikoff_canada/protobuf/types/pii/full_name_pb";
import { Name as UsNamePb } from "@repo/protobuf/gen/web/public/credit_monitoring_pb";
import type { UpdateNameRequest } from "@repo/protobuf/gen/web/public/onboarding_pb";
import { MessageFrom, PartialMessage } from "@repo/protobuf/utils";
import Telemetry from "@repo/telemetry";
import FullName from "@repo/utils/FullName";

export namespace FullNameUsa {
  export const normalize = (
    proto: MessageFrom<UpdateNameRequest> | MessageFrom<UsNamePb>
  ): FullName => {
    if ("givenName" in proto) {
      return {
        first: proto.givenName,
        middle: proto.middleName,
        last: proto.surname,
      };
    }

    if ("firstName" in proto) {
      return {
        first: proto.firstName,
        middle: proto.middleName,
        last: proto.lastName,
      };
    }

    Telemetry.captureError(
      new Error("Unexpected proto passed to FullName normalizer.")
    );

    return { first: "", last: "" } as never;
  };
  export const denormalize = (
    fullName: FullName
  ): PartialMessage<UpdateNameRequest> => ({
    givenName: fullName.first,
    middleName: fullName.middle,
    surname: fullName.last,
  });
}

export namespace FullNameCanada {
  export const normalize = (
    proto: MessageFrom<CanadaFullNamePb>
  ): FullName => ({
    first: proto.firstName,
    middle: proto.middleName,
    last: proto.lastName,
  });
  export const denormalize = (
    fullName: FullName
  ): MessageFrom<CanadaFullNamePb> => ({
    firstName: fullName.first,
    middleName: fullName.middle,
    lastName: fullName.last,
  });
}
